import Vue from "vue";
import { pluralize } from "./pluralize";
import { localeField } from "./localeField";
import { image } from "./image";
import { formatPrice } from "./formatPrice";

export const initFilters = () => {
  Vue.filter("pluralize", pluralize);
  Vue.filter("localeField", localeField);
  Vue.filter("image", image);
  Vue.filter("formatPrice", formatPrice);
};
